import View from './view';

export default View.extend( {
    
    events: {
        'click .-possible-value-add-start'() {
            this.trigger( 'possible-value:add-start' );
        },
    },

    serialize() {
        const {rootProperty, editingValueModel, roles} = this.options;
        const {
            possible_values: values, 
            type,
            default_value,
        } = rootProperty;
        const sorted = [...values].sort( (a, b) => a.order_index - b.order_index );

        let defaults;
        switch (type) {
            case 'BOOLEAN': 
                if (default_value !== null) 
                    defaults = { value: default_value }; 
                break;
            case 'DOUBLE': 
                if (default_value !== null) 
                    defaults = { value: default_value }; 
                break;
            case 'INTEGER': 
                if (default_value !== null) 
                    defaults = { value: default_value }; 
                break;
            case 'STRING': 
                if (default_value !== null) 
                    defaults = { value: default_value }; 
                break;
        }

        return { 
            values: sorted, 
            type, 
            editingValueModel, 
            defaults,
            roles,
        };
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/config.value.list.js